async function getShopifyThemeId(): Promise<string | null> {
  try {
    const res = await fetch("/PrintProductApps/CaPPUser/GetShopifyThemeId");
    if (!res.ok) return null;
    const json = await res.json();
    // The backend returns either a string themeId or "Failed"
    if (!json || json === "Failed") return null;
    return String(json);
  } catch {
    return null;
  }
}

export async function IsFeatureFlagEnabled(key: string): Promise<boolean> {
  const baseUrl = process.env.REACT_APP_ROUTING_API_BASE;

  const themeId = await getShopifyThemeId();

  const queryParams = new URLSearchParams({ key });
  if (themeId) {
    queryParams.set("themeId", themeId);
  }

  const res = await fetch(
    `${baseUrl}/theme-feature-flag?${queryParams.toString()}`,
    {
      headers: {
        "xCorrelationID": crypto.randomUUID(),
        "x-client-id": process.env.REACT_APP_CLIENT_ID!,
        "x-api-key": process.env.REACT_APP_API_KEY!,
      },
    }
  );

  if (res.status === 404) return false;
  if (!res.ok) return false;
  const json = await res.json();
  return json?.value === true || json?.value === "true";
}